/**
 * @file Utility functions to determine robot type based on serial number
 * Serial numbers starting with "0000" are Robot (Tessa)
 * Serial numbers not starting with "0000" are Voice Assistant (Orianna)
 */

/**
 * Determines if a device is a Voice Assistant (Orianna) based on its serial number
 * @param serial - The robot serial number
 * @returns true if the device is a Voice Assistant, false if it's a Robot
 */
export const isVoiceAssistant = (serial: string | undefined): boolean => {
  if (!serial) return false
  return !serial.startsWith('0000')
}

/**
 * Determines if a device is a Robot (Tessa) based on its serial number
 * @param serial - The robot serial number
 * @returns true if the device is a Robot, false if it's a Voice Assistant
 */
export const isRobot = (serial: string | undefined): boolean => {
  if (!serial) return false
  return serial.startsWith('0000')
}
